/* nd-lp2.js — shared behavior for the LP2 (ndlp2-*) funnel sections.
   Requires ndlp2-jquery.min.js + ndlp2-swiper.min.js loaded first
   (both emitted by the LP2 Header section). Guarded so double-loading is a no-op. */
(function () {
  if (window.__ndlp2Init) { return; }
  window.__ndlp2Init = true;

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  /* ---- arrives-by date ----
     BUG FIX 2026-08-07: this printed `new Date()` with no offset applied, so the
     line rendered "Order today, arrives by <today>" — the page was promising
     same-day delivery on every view. Now: today + N business days (weekends
     skipped). N comes from data-days on the element; default 5, which sits inside
     the 2-7 business day window stated in the shipping policy.
     Lives outside the jQuery block on purpose — if jQuery fails to load, the date
     still renders rather than leaving the strip blank. */
  ready(function () {
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    var nodes = document.querySelectorAll('[data-ndlp2-arrives]');
    Array.prototype.forEach.call(nodes, function (el) {
      var n = parseInt(el.getAttribute('data-days'), 10);
      if (!(n > 0)) { n = 5; }
      var d = new Date();
      var added = 0;
      while (added < n) {
        d.setDate(d.getDate() + 1);
        var wd = d.getDay();
        if (wd !== 0 && wd !== 6) { added++; }
      }
      el.textContent = days[d.getDay()] + ', ' + months[d.getMonth()] + ' ' + d.getDate();
    });
  });

  /* ---- guarantee line disclosure ----
     Added 2026-08-07. Heatmap logged repeated dead taps on the money-back line
     under the CTAs (and on the hero bullets) — people tap reassurance copy
     expecting it to open. The line is now a <button> that expands the actual
     terms. Delegated on document so it survives any later DOM injection, and
     kept out of the jQuery block so it works even if jQuery is missing. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    var btn = t.closest('[data-ndlp2-mbk]');
    if (!btn) { return; }
    e.preventDefault();
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) { return; }
    var isOpen = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    panel.hidden = isOpen;
  });

  ready(function () {
    var $ = window.jQuery;
    if (!$) { return; }

    /* ---- smooth-scroll all CTAs to the buy box ----
       LP test backlog #2 (2026-08-04): 350ms (was 2000ms; the slow drift let users
       flick-scroll against it or bail). Landing kept at the TOP of #select_package
       (product image first) — Patrick's call: buyers arriving via the CTA haven't
       really seen the product yet, so don't skip the image to the tier row.
       .stop(true) kills any in-flight animation so repeat taps don't queue/fight. */
    $(document).on('click', '.ndlp2 .btn_scorall', function () {
      var target = $('#select_package');
      if (!target.length) { return; }
      $('html, body').stop(true).animate({ scrollTop: target.offset().top - 40 }, 350);
    });

    /* ---- sticky header state ---- */
    $(document).on('scroll', function () {
      $('.ndlp2 .fixed_header_bar').toggleClass('fixed_nav', $(this).scrollTop() > 110);
    });

    /* ---- UGC video modal (shared; markup lives in the LP2 Header section) ---- */
    var modal = document.querySelector('.ndlp2 .ugc-modal');
    if (modal) {
      var vid = modal.querySelector('#myVdo video');
      function closeModal() {
        if (vid) { vid.pause(); vid.currentTime = 0; vid.src = ''; }
        $(modal).removeClass('active');
        $(modal).find('.video-container').hide();
      }
      $(document).on('click', '.ndlp2 .ugc1', function () {
        $(modal).addClass('active');
        $(modal).find('.video-container').show();
        if (vid) { vid.src = $(this).attr('data-vdo') || ''; vid.load(); vid.play(); }
      });
      $(modal).find('.video-container').on('click', function (e) { e.stopPropagation(); });
      $(modal).find('.ugc-close').on('click', closeModal);
      $(modal).on('click', function (e) { if ($(e.target).hasClass('ugc-modal')) { closeModal(); } });
    }

    /* ---- inline founder video posters ---- */
    $('.ndlp2 .s1_video-poster').on('click', function () {
      $(this).hide();
      $(this).closest('.sec1_founder_img_box').find('video[controls]').show().get(0).play();
    });

    /* ---- Swiper carousels (guard on lib + element presence) ---- */
    if (window.Swiper) {
      document.querySelectorAll('.ndlp2 .mySwiper').forEach(function (el) {
        var sw = new Swiper(el, {
          loop: true, speed: 600, centeredSlides: true, slidesPerView: 1.2, spaceBetween: 25,
          observer: true, observeParents: true,
          pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
          breakpoints: {
            0: { slidesPerView: 1.5, spaceBetween: 15 },
            640: { slidesPerView: 2, spaceBetween: 15 },
            768: { slidesPerView: 3, spaceBetween: 15 },
            1024: { slidesPerView: 4, spaceBetween: 15 },
            1200: { slidesPerView: 5, spaceBetween: 15 }
          }
        });
        window.addEventListener('load', function () { sw.update(); });
      });

      document.querySelectorAll('.ndlp2 .testimonial-row').forEach(function (el) {
        new Swiper(el, {
          spaceBetween: 25, slidesPerView: 3, loop: true,
          navigation: { nextEl: el.querySelector('.swiper-button-next'), prevEl: el.querySelector('.swiper-button-prev') },
          pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
          breakpoints: {
            0: { slidesPerView: 1.25, spaceBetween: 12, parallax: true, centeredSlides: true },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3, spaceBetween: 20 }
          }
        });
      });

      document.querySelectorAll('.ndlp2 .s10-left').forEach(function (wrap) {
        var thumbEl = wrap.querySelector('.thumbSwiper');
        var mainEl = wrap.querySelector('.mainSwiper');
        if (!thumbEl || !mainEl) { return; }
        var thumbs = new Swiper(thumbEl, { spaceBetween: 7, slidesPerView: 5, freeMode: true, watchSlidesProgress: true });
        new Swiper(mainEl, {
          spaceBetween: 10, loop: true, speed: 600,
          thumbs: { swiper: thumbs },
          navigation: { nextEl: thumbEl.querySelector('.swiper-button-next'), prevEl: thumbEl.querySelector('.swiper-button-prev') }
        });
      });
    }

    /* ---- FAQ accordion ---- */
    $('.ndlp2 .acdn-heading').on('click', function () {
      var questionDiv = $(this);
      var answerDiv = $(this).next('.acdn-content');
      $('.ndlp2 .acdn-content').not(answerDiv).filter(':visible').slideUp(500, function () {
        $(this).prev('.acdn-heading').removeClass('accordion-open');
      });
      if (answerDiv.is(':visible')) {
        answerDiv.stop().slideUp(500, function () { questionDiv.removeClass('accordion-open'); });
      } else {
        questionDiv.addClass('accordion-open');
        answerDiv.stop().slideDown(500);
      }
    });

    /* ---- animated counters + progress bars (sections 4 & 6) ---- */
    function vanillaCounter(el) {
      var start = parseInt(el.getAttribute('data-start-at')) || 0;
      var end = parseInt(el.getAttribute('data-end-at')) || 0;
      var delay = parseInt(el.getAttribute('data-delay')) || 0;
      var time = parseInt(el.getAttribute('data-time')) || 1000;
      var counter = start;
      var stepTime = Math.abs(Math.floor(time / (end - start || 1)));
      el.innerHTML = counter;
      setTimeout(function () {
        var interval = setInterval(function () {
          counter += (end > start ? 1 : -1);
          el.innerHTML = counter;
          if (counter === end) { clearInterval(interval); }
        }, stepTime);
      }, delay);
    }
    function inViewport(el, offset) {
      if (!el) { return false; }
      return el.getBoundingClientRect().top <= (offset || 600);
    }
    var triggeredSec6 = false, triggeredSec4 = false;
    $(window).on('scroll', function () {
      var sec6 = document.querySelector('.ndlp2 .running-bar');
      if (sec6 && !triggeredSec6 && inViewport(sec6, 400)) {
        triggeredSec6 = true;
        $('.ndlp2 .sec6_content_inner_row').each(function (idx) {
          var value = $(this).attr('data-wdth');
          var $bar = $(this).find('.sec6_progress_inr');
          setTimeout(function () { $bar.css('width', value + '%'); }, idx * 300);
        });
        sec6.querySelectorAll('[data-vanilla-counter]').forEach(function (el, idx) {
          setTimeout(function () { vanillaCounter(el); }, idx * 300);
        });
      }
      var sec4 = document.querySelector('.ndlp2 .s4_running-bar');
      if (sec4 && !triggeredSec4 && inViewport(sec4, 600)) {
        triggeredSec4 = true;
        $('.ndlp2 .sec4_col_cont_bottom').each(function (idx) {
          var value = $(this).attr('data-wdth');
          var $bar = $(this).find('.s4_col_progress_inr');
          setTimeout(function () { $bar.css('width', value + '%'); }, idx * 300);
        });
        sec4.querySelectorAll('[data-vanilla-counter]').forEach(function (el, idx) {
          setTimeout(function () { vanillaCounter(el); }, idx * 300);
        });
      }
    });

    /* ---- countdown timer(s): headline strip + offer strip share one deadline ---- */
    (function () {
      var holder = document.querySelector('[data-ndlp2-countdown-minutes]');
      var minutes = holder ? parseInt(holder.getAttribute('data-ndlp2-countdown-minutes'), 10) : 10;
      if (!minutes || minutes < 1) { minutes = 10; }
      var deadline = new Date(Date.now() + minutes * 60 * 1000);
      function pad(n) { return ('0' + n).slice(-2); }
      function tick() {
        var t = Math.max(0, deadline - Date.now());
        var h = Math.floor(t / 3600000), m = Math.floor(t / 60000) % 60, s = Math.floor(t / 1000) % 60;
        document.querySelectorAll('.ndlp2 #clockdiv').forEach(function (clock) {
          var hs = clock.querySelector('.hours'), ms = clock.querySelector('.minutes'), ss = clock.querySelector('.seconds');
          if (hs) { hs.innerHTML = pad(h); }
          if (ms) { ms.innerHTML = pad(m); }
          if (ss) { ss.innerHTML = pad(s); }
        });
        var str = pad(h) + ':' + pad(m) + ':' + pad(s) + ' ';
        document.querySelectorAll('.ndlp2 .listicle-count').forEach(function (el) { el.innerHTML = str; });
        if (t <= 0) { clearInterval(iv); }
      }
      tick();
      var iv = setInterval(tick, 1000);
    })();
  });
})();
